import axios, { InternalAxiosRequestConfig } from 'axios';

const api = axios.create({
    baseURL: window.location.hostname === 'localhost' 
        ? `http://localhost:4000/api` 
        : `/api`
});

// Middleware de Axios para incluir el Token en cada petición automáticamente
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('milco_token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Interceptor de Respuestas para manejar errores de autenticación
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Limpiar datos de sesión locales únicamente cuando el token expiró o es inválido (401)
            localStorage.removeItem('milco_token');
            localStorage.removeItem('milco_user');
            
            // Redirigir al login si no está allí
            if (window.location.pathname !== '/') {
                window.location.href = '/?session_expired=true';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
